import React from 'react';

const LogoMark = ({ className = 'w-8 h-8' }: { className?: string }) => (
  <svg
    viewBox="0 0 32 32"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="0.5" y="0.5" width="31" height="31" rx="7" stroke="currentColor" strokeOpacity="0.25" />
    <rect x="7" y="7" width="18" height="18" rx="3" stroke="#C6F24E" strokeWidth="1.5" />
    <rect x="12" y="12" width="8" height="8" fill="#C6F24E" />
  </svg>
);

const Logo = ({
  className = 'h-8',
  showText = true,
}: {
  className?: string;
  showText?: boolean;
}) => {
  return (
    <div className={`flex items-center gap-2.5 text-white ${className}`}>
      <LogoMark className="h-full w-auto aspect-square" />
      {showText && (
        <span className="text-[15px] md:text-base font-semibold tracking-[-0.02em] text-white leading-none">
          Emerge<span className="text-zinc-500 font-medium">/</span>Automations
        </span>
      )}
    </div>
  );
};

export default Logo;
